var notify = {

    success: function (text, additional_options) {
        var options = {
            message: text,
            layout: 'bottomRight',
            theme: 'relax',
            type: 'success',
            timeout: 7000,
            animation: {
                open: 'animated tada', // jQuery animate function property
                close: 'animated rotateOutDownRight', // jQuery animate
                easing: 'swing', // easing
                speed: 500
            },
            callback: {
                onClose: function () {

                },

                afterShow: function () {

                }
            }
        };

        options = $.extend(options, additional_options);
        $.notify(options, 'success');
    },

    error: function (text, additional_options) {
        $.notify(text, "danger", additional_options);
    },

    info: function () { },
    warn: function (text, additional_options) {
        $.notify(text, "warning", additional_options);
    },
};
